export const formatNumber = (num) => {
  if (num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  else {
    return 'NA'
  }
};

export const sortObjectArrayDesc = (arr, property, num) => {
  return arr.sort(function (ob1, ob2) { return ob2[property] - ob1[property] }).slice(0, num)
}